import { useTranslation } from 'react-i18next'

import { BaseModalType } from '@context/ModalsContext'

import { Modal } from '@ui/components/Modal'

import { useWindowResize } from '@utils/domUtils'

import { TradingAccount } from '@model/TradingAccount'

import { SwapFreeGuideTab } from '../components/SwapFreeGuideTab'
import { SwapFreeRatingTab } from '../components/SwapFreeRatingTab'

interface SwapFreeInfoModalProps {
  tradingAccount: TradingAccount
}

export const SwapFreeInfoModal: BaseModalType<SwapFreeInfoModalProps> = (props) => {
  const { tradingAccount, close } = props
  const { t } = useTranslation()

  const isMobile = useWindowResize()

  return (
    <Modal>
      <Modal.Header canClose>{t('Swap Free.Swap Free Account')}</Modal.Header>
      <Modal.Body>
        <Modal.Body.Tabs initialIndex={0} fullWidth center>
          <Modal.Body.Tabs.Tab id='rating' title={t('Swap Free.Modal.Tab.Rating')}>
            <SwapFreeRatingTab tradingAccount={tradingAccount} onClose={close} />
          </Modal.Body.Tabs.Tab>
          <Modal.Body.Tabs.Tab id='guide' title={t('Swap Free.Modal.Tab.Guide')}>
            <SwapFreeGuideTab
              onClose={close}
              daysTillSuspended={tradingAccount?.swapFreeOption?.daysTillSuspended}
            />
          </Modal.Body.Tabs.Tab>
        </Modal.Body.Tabs>
      </Modal.Body>
      {isMobile && (
        <Modal.Footer>
          <Modal.Footer.Secondary onClick={close}>{t('Got it')}</Modal.Footer.Secondary>
        </Modal.Footer>
      )}
    </Modal>
  )
}
